/* Plain Gage Tolerance Calculator — sections/plain-gage-calculator.liquid.
   ASME B89.1.5 gagemaker's tolerance classes; GO / NO GO sizes with tolerance applied inside the
   part limits. Stock classes and size coverage mirror the live store as of 2026-10-20. */
(function(){
"use strict";
const root=document.getElementById("pgc");
if(!root) return;
const PHONE=root.dataset.phone||"1-888-400-4243";
const QUOTE=root.dataset.quoteUrl||"/pages/express-gage-quote";
const $=id=>document.getElementById(id);

/* ASME B89.1.5 gagemaker's tolerance by diameter band (above, including). Inch and mm tables as published;
   the mm XXX column is converted from inch (the published mm table starts at XX). */
const CLASSES=["XXX","XX","X","Y","Z","ZZ"];
const TOL_IN=[
  [.010,.825,[.000010,.000020,.000040,.000070,.000100,.000200]],
  [.825,1.510,[.000015,.000030,.000060,.000090,.000120,.000240]],
  [1.510,2.510,[.000020,.000040,.000080,.000120,.000160,.000320]],
  [2.510,4.510,[.000025,.000050,.000100,.000150,.000200,.000400]],
  [4.510,6.510,[.000033,.000065,.000130,.000190,.000250,.000500]],
  [6.510,9.010,[.000040,.000080,.000160,.000240,.000320,.000640]],
  [9.010,12.010,[.000050,.000100,.000200,.000300,.000400,.000800]]];
const TOL_MM=[
  [.254,20.96,[.00025,.00051,.00102,.00178,.00254,.00508]],
  [20.96,38.35,[.00038,.00076,.00152,.00229,.00305,.00610]],
  [38.35,63.75,[.00051,.00102,.00203,.00305,.00406,.00813]],
  [63.75,114.55,[.00064,.00127,.00254,.00381,.00508,.01016]],
  [114.55,165.35,[.00084,.00165,.00330,.00483,.00635,.01270]],
  [165.35,228.85,[.00102,.00203,.00406,.00610,.00813,.01626]],
  [228.85,305.05,[.00127,.00254,.00508,.00762,.01016,.02032]]];
const STOCK=["XX","X","Y","Z"];

/* What WESTport stocks, by inch diameter. */
const PLUGS=[
  {title:"Reversible Plug Gage",lo:.010,hi:1.010,mats:[["Steel","cylindrical-reversible-plug-gage-steel"],["Chrome","cylindrical-reversible-plug-gage-chrome"],["Carbide","cylindrical-reversible-plug-gage-carbide",.040,.761]]},
  {title:"Taperlock Plug Gage",lo:.1051,hi:1.510,mats:[["Steel","taperlock-cylindrical-plug-gage-steel"],["Chrome","taperlock-cylindrical-plug-gage-chrome"]]},
  {title:"Trilock Plug Gage",lo:.760,hi:8.010,mats:[["Steel","trilock-cylindrical-plug-gage-steel"],["Chrome","trilock-cylindrical-plug-gage-chrome"]]}];
const RINGS=[
  {title:"Plain Ring Gage",lo:.015,hi:7.010,mats:[["Steel","cylindrical-ring-gage-steel"],["Chrome","cylindrical-ring-gage-chrome",.1501,7.010],["Carbide","cylindrical-ring-gage-carbide",.040,2.510]]}];

function band(table,d){return table.find(b=>d>b[0]&&d<=b[1])||(d<=table[0][0]?null:null);}
const num=v=>{const x=parseFloat(String(v).trim());return isFinite(x)?x:NaN;};

let units="in";
function fmt(x){return units==="in"?x.toFixed(6).replace(/0{1,2}$/,""):x.toFixed(5);}
function fmtSize(x){return units==="in"?x.toFixed(4):x.toFixed(3);}

function calc(){
  const lo=num($("min").value), hi=num($("max").value), out=$("out"), err=$("err");
  const feat=$("feature").value, rule=+$("rule").value, force=$("cls").value;
  units=$("unit").value;
  document.querySelectorAll(".pgc-u").forEach(e=>e.textContent=units);
  if(!(lo>0)||!(hi>0)){err.hidden=true;out.hidden=true;return;}
  if(hi<=lo){err.textContent="The maximum must be larger than the minimum.";err.hidden=false;out.hidden=true;return;}
  const tbl=units==="in"?TOL_IN:TOL_MM, b=band(tbl,hi);
  if(!b){err.textContent=units==="in"?"Standard gage classes cover 0.010 in to 12.010 in. Call "+PHONE+" for other sizes.":"Standard gage classes cover 0.254 mm to 305.05 mm. Call "+PHONE+" for other sizes.";err.hidden=false;out.hidden=true;return;}
  err.hidden=true;
  const partTol=hi-lo, allowed=partTol*rule;
  // Loosest class whose tolerance still fits the rule (looser = cheaper)
  let sug=null; for(let i=CLASSES.length-1;i>=0;i--){ if(b[2][i]<=allowed+1e-12){sug=CLASSES[i];break;} }
  const cls=force||sug;
  const T=cls?b[2][CLASSES.indexOf(cls)]:null;

  let html=`<div class="facts">
    <span>Part tolerance <b>${fmt(partTol)} ${units}</b></span>
    <span>Allowed per gage (${Math.round(rule*100)}%) <b>${fmt(allowed)} ${units}</b></span>
    <span>Suggested class <b>${sug||"tighter than XXX"}</b></span></div>`;
  if(!cls){
    html+=`<p class="clsnote">This part tolerance is tighter than any standard gage class allows under the ${Math.round(rule*100)}% rule. WESTport can quote special gages or measurement instead: call ${PHONE}.</p>`;
    out.innerHTML=html; out.hidden=false; return;
  }
  let stockNote="";
  if(!STOCK.includes(cls)){
    stockNote=cls==="ZZ"
      ?`WESTport stocks Classes XX to Z. Class Z is tighter than ZZ, so a stock Class Z gage also meets this requirement.`
      :`Class ${cls} is a special order. Call ${PHONE} or request a quote.`;
  }
  if(force&&force!==sug&&sug) stockNote=(stockNote?stockNote+" ":"")+(CLASSES.indexOf(force)<CLASSES.indexOf(sug)
    ?`Class ${force} is tighter than needed, which is fine but costs more.`
    :`Class ${force} is looser than the ${Math.round(rule*100)}% rule suggests; the gage will use more of your part tolerance.`);
  const plug=feat==="hole";
  const go=plug?{size:lo,tol:`+${fmt(T)} / −0`,lim:[lo,lo+T]}:{size:hi,tol:`+0 / −${fmt(T)}`,lim:[hi-T,hi]};
  const ng=plug?{size:hi,tol:`+0 / −${fmt(T)}`,lim:[hi-T,hi]}:{size:lo,tol:`+${fmt(T)} / −0`,lim:[lo,lo+T]};
  const pct=(100*T/partTol).toFixed(1);
  html+=`<div class="grid2" style="margin-top:1.6rem">
    <div class="member"><span class="tag go">GO</span><span class="what">${plug?"Plug gage, enters the hole":"Ring gage, passes over the shaft"}<br>Class ${cls}, ${go.tol} ${units}</span><span class="val">${fmtSize(go.size)}</span></div>
    <div class="member"><span class="tag nogo">NO GO</span><span class="what">${plug?"Plug gage, must not enter":"Ring gage, must not pass over"}<br>Class ${cls}, ${ng.tol} ${units}</span><span class="val">${fmtSize(ng.size)}</span></div></div>
    <p class="sub" style="margin-top:1rem">Gage tolerance is applied inside the part limits, so a gage at either end of its tolerance never accepts a bad part. Each gage uses ${pct}% of the part tolerance.</p>`;
  if(stockNote) html+=`<p class="clsnote">${stockNote}</p>`;
  html+=shop(plug,hi,lo,STOCK.includes(cls)?cls:(cls==="ZZ"?"Z":null));
  out.innerHTML=html; out.hidden=false;
}

function shop(plug,hi,lo,cls){
  const dIn=units==="in"?[lo,hi]:[lo/25.4,hi/25.4];
  const fits=(a,b)=>dIn[0]>a&&dIn[1]<=b;
  const lines=(plug?PLUGS:RINGS).filter(l=>fits(l.lo,l.hi));
  if(!lines.length||!cls) return `<div class="shop" style="margin-top:1.2rem"><a class="btn primary" href="${QUOTE}">Request a quote</a></div>`;
  const btns=[];
  lines.forEach(l=>l.mats.forEach(([m,h,a,b])=>{ if(a&&!fits(a,b)) return; btns.push(`<a class="btn ${btns.length?"ghost":"primary"}" href="/products/${h}">${l.title} · ${m}</a>`); }));
  return `<h3 style="margin-top:1.6rem">${plug?"Plug gages":"Ring gages"} in stock for this size</h3><div class="shop" style="margin-top:.8rem">${btns.join("")}</div>
    <p class="sub" style="margin-top:.8rem">On the product page, choose the size range that contains your dimension, Class <b>${cls}</b>, and GO, NO GO or both.</p>`;
}

["min","max"].forEach(id=>$(id).addEventListener("input",calc));
["unit","feature","rule","cls"].forEach(id=>$(id).addEventListener("change",calc));
document.querySelectorAll("[data-example]").forEach(b=>b.onclick=()=>{
  const [u,f,lo,hi]=b.dataset.example.split("|"); $("unit").value=u; $("feature").value=f; $("min").value=lo; $("max").value=hi; calc();});
calc();
window.__pgc={TOL_IN,TOL_MM,CLASSES};
})();
